module.exports = __webpack_public_path__ + "static/img/5.9e9cab5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/screenshot/5.png
// module id = UM8i
// module chunks = 0